export const CATALOG_FILTERS = [
  { id: 'All', label: 'All Products' },
  { id: 'Rice', label: 'Rice' },
  { id: 'Grain', label: 'Grains' },
  { id: 'Seasonal', label: 'Seasonal Fruits & Vegetables' },
  { id: 'Seasonal Fruit', label: 'Seasonal Fruits' },
  { id: 'Vegetable', label: 'Vegetables' },
];

export const STORE_FILTERS = {
  all: CATALOG_FILTERS,
  rice: [{ id: 'Rice', label: 'Rice Types' }],
  grainNonRice: [{ id: 'Grain', label: 'Grain Types' }],
};

export const SORT_OPTIONS = [
  { id: 'featured', label: 'Featured' },
  { id: 'priceLow', label: 'Low Price' },
  { id: 'priceHigh', label: 'High Price' },
  { id: 'newest', label: 'Newest' },
];

const normalize = (value) => String(value || '').trim().toLowerCase();
const normalizeForKeywordMatch = (value) =>
  normalize(value)
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const RICE_KEYWORDS = [
  'rice',
  'basmati',
  'sona masuri',
  'sona masoori',
  'kolam',
  'ponni',
  'jeera samba',
  'samba rice',
  'idli rice',
  'idly rice',
  'brown rice',
  'raw rice',
  'boiled rice',
  'matta',
  'gobindobhog',
];

export const isGrainProduct = (product) => normalize(product?.category) === 'grain';

export const isSeasonalProduct = (product) => {
  const category = normalize(product?.category);
  return category === 'seasonal fruit' || category === 'vegetable';
};

export const isRiceProduct = (product) => {
  if (!isGrainProduct(product)) return false;

  const haystack = [
    normalizeForKeywordMatch(product?.name),
    normalizeForKeywordMatch(product?.category),
  ]
    .filter(Boolean)
    .join(' ');

  return RICE_KEYWORDS.some((keyword) => haystack.includes(keyword));
};

export const isNonRiceGrainProduct = (product) => isGrainProduct(product) && !isRiceProduct(product);

export const matchesStoreScope = (product, scope = 'all') => {
  if (scope === 'rice') return isRiceProduct(product);
  if (scope === 'grainNonRice') return isNonRiceGrainProduct(product);
  return true;
};

export const matchesCatalogFilter = (product, filter) => {
  if (!filter || filter === 'All') return true;

  const category = normalize(product?.category);

  if (filter === 'Rice') return isRiceProduct(product);
  if (filter === 'Seasonal') return isSeasonalProduct(product);
  if (filter === 'Grain') return isNonRiceGrainProduct(product);
  if (filter === 'Seasonal Fruit') return category === 'seasonal fruit';
  if (filter === 'Vegetable') return category === 'vegetable';

  return normalize(filter) === category;
};

const bySearch = (product, query) => {
  if (!query) return true;
  const q = normalize(query);
  return normalize(product?.name).includes(q) || normalize(product?.farmerId?.name).includes(q);
};

export const filterAndSortProducts = (
  products,
  {
    searchQuery = '',
    selectedCategory = 'All',
    sortBy = 'featured',
    storeScope = 'all',
  } = {}
) => {
  const list = Array.isArray(products) ? products : [];
  const filtered = list.filter(
    (product) =>
      matchesStoreScope(product, storeScope) &&
      bySearch(product, searchQuery) &&
      matchesCatalogFilter(product, selectedCategory)
  );

  if (sortBy === 'priceLow') {
    return [...filtered].sort((a, b) => Number(a.pricePerKg || 0) - Number(b.pricePerKg || 0));
  }
  if (sortBy === 'priceHigh') {
    return [...filtered].sort((a, b) => Number(b.pricePerKg || 0) - Number(a.pricePerKg || 0));
  }
  if (sortBy === 'newest') {
    return [...filtered].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
  }

  return filtered;
};
